<br />
<div class="container">
  <h2>Vendor Invoice Submission</h2>
  <p>
    Please follow the instructions for invoice submission below.
    <span *ngIf="purchaseOrdersEnabled">
      If you are unsure what purchase order number your invoice pertains to, you
      can contact the Finance Department.
    </span>
  </p>

  <form novalidate [formGroup]="form" class="form-horizontal">
    <div class="col-md-6" *ngIf="purchaseOrdersEnabled">
      <div class="form-group">
        <div
          class="form-group"
          [ngClass]="{
            'has-error': !f['IsPo'].valid && submitted,
            'checked-state': f['IsPo'].value,
          }"
        >
          <input
            type="checkbox"
            class="form-check-input"
            formControlName="IsPo"
            [style.backgroundColor]="
              f['IsPo'].value ? 'var(--tg-common-color-blue)' : 'white'
            "
            (change)="onIsPoChanged()"
          />
          <label class="inline form-check-label">
            Is there a Purchase Order associated with this invoice?
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group" *ngIf="form.get('IsPo')?.value">
          <label class="inline"
            >PO Number <span class="required">*</span></label
          >
          <div
            class="form-group"
            [ngClass]="{ 'has-error': !f['PoNumber'].valid && submitted }"
          >
            <input
              type="text"
              class="form-control txt-area-height"
              formControlName="PoNumber"
              pattern="[0-9]*"
              (input)="utilityService.onlyNumbers($event, form, 'PoNumber')"
            />
          </div>
        </div>
        <div class="form-group">
          <label class="inline"
            >Contact Name <span class="required">*</span></label
          >
          <div
            class="form-group"
            [ngClass]="{ 'has-error': !f['ContactName'].valid && submitted }"
          >
            <input
              type="text"
              class="form-control txt-area-height"
              formControlName="ContactName"
            />
          </div>
        </div>

        <div class="form-group">
          <label class="inline"
            >Invoice Date <span class="required">*</span></label
          >
          <div
            class="form-group"
            [ngClass]="{ 'has-error': f['InvoiceDate'].invalid && submitted }"
          >
            <input
              type="date"
              class="form-control txt-area-height"
              formControlName="InvoiceDate"
            />
          </div>
        </div>

        <div class="form-group">
          <label class="inline"
            >Invoice Description <span class="required">*</span></label
          >
          <div
            class="form-group"
            [ngClass]="{
              'has-error': f['InvoiceDescription'].invalid && submitted,
            }"
          >
            <textarea
              rows="2"
              class="form-control txt-area-height"
              formControlName="InvoiceDescription"
              maxlength="50"
            ></textarea>
            <div
              class="char-counter"
              [ngClass]="{ 'text-danger': isInvoiceDescriptionLimitExceeded() }"
            >
              <small
                >{{ getInvoiceDescriptionCharCount() }}/50 characters</small
              >
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label class="inline"
            >Contact Email <span class="required">*</span></label
          >
          <div
            class="form-group"
            [ngClass]="{ 'has-error': f['ContactEmail'].invalid && submitted }"
          >
            <input
              type="email"
              class="form-control txt-area-height"
              formControlName="ContactEmail"
            />
          </div>
        </div>
        <div class="form-group">
          <label class="inline"
            >Invoice Number <span class="required">*</span></label
          >
          <div
            class="form-group"
            [ngClass]="{ 'has-error': f['InvoiceNumber'].invalid && submitted }"
          >
            <input
              type="text"
              class="form-control txt-area-height"
              formControlName="InvoiceNumber"
            />
          </div>
        </div>
        <div class="form-group">
          <label class="inline">
            Invoice Amount <span class="required">*</span>
          </label>
          <div
            class="form-group"
            [ngClass]="{
              'has-error': f['OriginalPoAmount'].invalid && submitted,
            }"
          >
            <input
              type="number"
              class="form-control txt-area-height"
              formControlName="OriginalPoAmount"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="col-md-6">
          <button type="button" class="post-tag" (click)="fileInput.click()">
            <i class="pe-7s-plus"></i> Add Attachment/s (up to 45MB)
          </button>
          <input
            type="file"
            #fileInput
            [attr.accept]="utilityService.acceptedFileExtensions"
            (change)="onFileSelected($event, fileInput)"
            multiple
            style="display: none"
          />
        </div>
      </div>
    </div>

    <br />
    <div class="row" formArrayName="attachments">
      <div class="col-md-12">
        <div
          *ngFor="let item of filesArray.controls; let i = index"
          class="col-md-12 form-group file-display-container"
        >
          <div
            class="file-details d-flex justify-content-between align-items-center"
          >
            <span>{{ item.value.file?.name }}</span>
            <button type="button" class="btn-remove" (click)="removeFile(i)">
              <i class="skillgro-bin"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <br />

    <br />
    <div class="form-group">
      <small class="required">* Denotes Required Field</small>
    </div>
  </form>
  <div class="form-group">
    <div class="col-12 d-flex align-items-center">
      <button
        type="submit"
        class="btn btn-primary"
        style="margin-right: 10px"
        [disabled]="!canSubmit"
        (click)="onSubmit()"
      >
        Submit
      </button>
      <button type="reset" class="btn btn-reset" (click)="resetForm()">
        Reset
      </button>
    </div>
  </div>
</div>
